module.exports = __webpack_public_path__ + "static/surveymonkey-aa6421be2b02e0dd05682c0a3807ffb1.png";